import React from "react";
import "../styles/Navbar.css"; 
import logo from "../assets/logo.jpg"; // ✅ adjust path & filename

const Navbar = () => {
  return (
    <nav className="navbar">
      {/* ✅ Logo */}
      <div className="navbar-logo">
        <a href="#hero">
          <img src={logo} alt="PTS Logo" />
        </a>
      </div>

      {/* ✅ Menu */}
      <ul className="navbar-menu">
        <li><a href="#languages">Languages</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#why-pts">Why PTS</a></li>
        <li><a href="#contact">Contact Us</a></li>
        <li><a href="#quote" className="btn-quote">Get a Free Quote</a></li>
      </ul>
    </nav>
  );
};

export default Navbar;
